import { escapeRegExp } from './strings'

export { getSelectedText, getSelection, toggleCopyOnBody, dispatchCopyEventFrom, getVisuallyHiddenText, getClipboardText, removeScreenReaderText }

let preventCopyOnBodyApplied = false
function preventEventHandler(evt) {
  console.log('copy on body prevented')
  evt.preventDefault()
}

function getSelectedText() {
  var txt = ''
  if (window.getSelection) {
    txt = window.getSelection().toString()
  } else if (document.getSelection) {
    txt = document.getSelection().toString()
  } else if (document.selection) {
    txt = document.selection.createRange().text
  }
  return txt
}

function getClipboardText(stringToCopy) {
  let textToCopy = getSelectedText()
  if (!textToCopy || textToCopy.trim() === '') {
    textToCopy = stringToCopy
  }
  return textToCopy
}

function getSelection() {
  let selection = null
  if (window.getSelection) {
    selection = window.getSelection()
  } else if (document.getSelection) {
    selection = document.getSelection()
  }
  return selection
}

// true means detach prevent handler body element
// false means attach prevent handler
function toggleCopyOnBody(allowFlag) {
  if (!allowFlag && !preventCopyOnBodyApplied) {
    console.log('disabling copy on body element')
    document.body.addEventListener('copy', preventEventHandler)
    preventCopyOnBodyApplied = true
  }
  if (allowFlag && preventCopyOnBodyApplied) {
    console.log('allowing copy on body element')
    document.body.removeEventListener('copy', preventEventHandler)
    preventCopyOnBodyApplied = false
  }
}

// simulates a copy event; useful when we programmatically perform a copy (e.g. via a Copy button) but still want to trigger a browser copy event
function dispatchCopyEventFrom(domElm, fromButton, stringToCopy) {
  const detail = { fromButton: !!fromButton, stringToCopy, copyBlocked: false }
  if (domElm) {
    let evtOptions = {
      bubbles: true,
      cancelable: true,
      detail
    }
    let evt = new CustomEvent('copy', evtOptions)
    domElm.dispatchEvent(evt)
  }
  return detail
}

const hiddenStyleString = 'clip:rect(0 0 0 0); clip-path:inset(50%); height:1px; overflow:hidden; position:absolute; white-space:nowrap; width:1px;'

// Creates a visually hidden element for status messages that screen readers can announce.
const getVisuallyHiddenText = text => {
  const visuallyHiddenText = document.createElement('span')
  visuallyHiddenText.textContent = text
  visuallyHiddenText.setAttribute('class', 'visually-hidden')
  visuallyHiddenText.setAttribute('role', 'status')
  visuallyHiddenText.setAttribute('style', hiddenStyleString)
  return visuallyHiddenText
}

// Copying a selection picks up screen-reader-only text such as "(Opens in a new tab)".
// Remove each piece the page carries, with the whitespace it leaves behind. Only parenthesised
// labels qualify: unparenthesised ones are page chrome like "Close", which would otherwise be
// cut out of any copied prose containing that word.
const isParenthesised = text => text.startsWith('(') && text.endsWith(')')

function removeScreenReaderText(selectedText) {
  const hiddenTexts = new Set([...document.querySelectorAll('.sr-only')].map(el => el.textContent.trim()).filter(isParenthesised))
  return [...hiddenTexts].reduce((text, hiddenText) => {
    const escaped = escapeRegExp(hiddenText)
    return text.replace(new RegExp(`\\s*${escaped}\\s*(?=[.,!?:;])|${escaped}\\s+`, 'g'), '')
  }, selectedText)
}
